import moment from 'moment';
import DatePickerComponent from '../../../components/date-picker/date-picker.component';
import paginationComponent from '../../../components/pagination/pagination.component';
import SingleSelectComponent from '../../../components/single-select/single-select.component';
import SelectSiteSearchInputComponent from '../../../components/site/select-site-search-input.component';
import { formats } from '../../../config/constants';
import goodMovementModel from '../../../models/posm/goods-movement.model';
import POSMAuthorizationModel, { POSM_PERMISSION_KEY } from '../../../models/posm/posm-authority.model';
import ViewBase from '../../view-base.view';
import CreatePOSMGoodsIssueApplicationDialog from './create-goods-issue-application.view';
import MultiplePOSMLevelSelect from './filters/multiple-posm-level-select.view';
import StorageLocationSelect from './filters/storage-location-select.view';
import { downloadGoodsApplicationList, getApplicationList } from '../../../models/posm/posm-goods-issue-application.model';
import UpdatePOSMGoodsIssueApplicationDialog from './update-goods-issue-application.view';
import { ASCENDING_TEXT, DESCENDING_TEXT } from '../../../models/posm/posm.constant';

/**
 * POSM Goods Issue Application
 * This function provides another means to issue goods by getting approval for goods issue prior to actual goods issue. 
 *
 * @author cmc.nkhiep
 */

export const APPROVAL_STATUSES = {
  PendingSubmission: { code: 'PDS', name: 'Pending Submission' },
  PendingApproval: { code: 'PDA', name: 'Pending Approval' },
  PendingApproval2: { code: 'PDA2', name: 'Pending Approval 2' },
  CompletedSuccessfully: { code: 'COMP', name: 'Completed Successfully' },
  Rejected: { code: 'REJ', name: 'Rejected' },
};

export default function POSMGoodsIssueApplication() {
  ViewBase.call(this);
  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    total: 0
  }
  const DEFAULT_FILTERS = {
    DateFrom: moment().subtract(1, 'M').startOf('M').format(formats.apiDateFormat),
    DateTo: moment().format(formats.apiDateFormat),
    ChannelCode: [],
    ApprovalStatusCode: "",
    main: { code: null, name: null },
    goodsType: { code: null, name: null },
    division: { code: null, name: null },
    model: { code: null, name: null },
    basicModel: { code: null, name: null },
    warehouse: { code: null, name: null },
    storageLocation: { code: null, name: null }
  };
  const DEFAULT_GOODS_HIERARCHY = {
    main: { code: null, name: null },
    goodsType: { code: null, name: null },
    division: { code: null, name: null },
    model: { code: null, name: null },
    basicModel: { code: null, name: null },
    currentInputGoodTypeOrder: 0
  };
  const DEFAULT_WAREHOUSE_STORAGE = {
    warehouse: { code: null, name: null },
    storageLocation: { code: null, name: null }
  };

  let listGIApplication = [];

  let searchFilters = structuredClone(DEFAULT_FILTERS);
  let paginationObj = structuredClone(DEFAULT_PAGINATION);
  let currentFilter = structuredClone(DEFAULT_FILTERS);
  let selectedGoodsHierarchy = structuredClone(DEFAULT_GOODS_HIERARCHY);
  let selectedWarehouseStorageItem = structuredClone(DEFAULT_WAREHOUSE_STORAGE);

  let isCreateApplicationDialogOpen = false;

  let warehouseList = [''];
  let selectedMovementControlId = ''

  const setPaginationObj = (paginationObjPatch) => {
    paginationObj = { ...paginationObj, ...paginationObjPatch };
    currentFilter = { ...currentFilter, ...paginationObj };
  }

  const setSearchFilter = (selectedObj) => {
    searchFilters = { ...searchFilters, ...selectedObj }
  }
  const setSelectedGoodsHierarchy = (selectedObj) => {
    selectedGoodsHierarchy = { ...selectedGoodsHierarchy, ...selectedObj }
  }
  const setSelectedWarehouseStorageItem = (selectedObj) => {
    selectedWarehouseStorageItem = { ...selectedWarehouseStorageItem, ...selectedObj }
  }

  const setCurrentFilter = () => {
    currentFilter = { ...searchFilters, ...selectedGoodsHierarchy, ...selectedWarehouseStorageItem }
  }

  const DEFAULT_COLUMNS = {
    RowNum: 'RowNum',
    MovementControlId: 'MovementControlId',
    MovementDate: 'MovementDate',
    GoodsIssueDate: 'GoodsIssueDate',
    SubName: 'SubName',
    GoodsName: 'GoodsName',
    GoodsControlId: 'GoodsControlId',
    MovementQty: 'MovementQty',
    MovementBy: 'MovementBy',
    FromWarehouse: 'FromWarehouse',
    FromStorage: 'FromStorage',
    ChannelCode: 'ChannelCode',
    ChannelName: 'ChannelName',
    Owner: 'Owner',
    PhoneNo: 'PhoneNo',
    Address: 'Address',
    ApproveBy: 'ApproveBy',
    ApproveDate: 'ApproveDate',
    ApproveBy2: 'ApproveBy2',
    ApproveDate2: 'ApproveDate2',
    ApprovalStatus: 'ApprovalStatus',
    MovementMasterControlId: 'MovementMasterControlId',
    Remarks: 'Remarks',
    FileId1: 'FileId1',
    FileId2: 'FileId2',
    FileId3: 'FileId3',
    FileId4: 'FileId4',
    FileId5: 'FileId5',
    FileName1: 'FileName1',
    FileName2: 'FileName2',
    FileName3: 'FileName3',
    FileName4: 'FileName4',
    FileName5: 'FileName5',
  }

  const parseListApplication = (dataTable) => {
    return dataTable.map(item => {
      let newItem = { warehouses: {} }
      for (let props in item) {
        if (Object.hasOwn(DEFAULT_COLUMNS, props)) {
          newItem[props] = item[props];
          continue;
        }
        newItem.warehouses[props] = item[props];
      }
      return newItem
    })
  }

  const requestParams = {
    get pageIndex() {
      return paginationObj.pageIndex
    },
    get pageSize() {
      return paginationObj.pageSize
    },
    get sortBy() {
      if (sortObj.sortBy)
        return `[${sortObj.sortBy}]`
    },
    get orderBy() {
      return sortObj.orderBy
    },
    get DateFrom() {
      return currentFilter.DateFrom
    },
    get DateTo() {
      return currentFilter.DateTo
    },
    get GoodsId() {
      return currentFilter.basicModel.id
    },
    get WarehouseId() {
      return currentFilter.warehouse.code
    },
    get StorageId() {
      return currentFilter.storageLocation.code
    },
    get ChannelCode() {
      return currentFilter.ChannelCode.map(({ siteId }) => siteId).join('^')
    },
    get ApprovalStatusCode() {
      return currentFilter.ApprovalStatusCode
    },
  }

  const getTableDataList = () => {
    this.showLoading();
    setCurrentFilter()
    getApplicationList(requestParams)
      .then((data) => {
        if (data != null && data.data != null) {
          paginationObj.total = data.total;
          listGIApplication = parseListApplication(data.data);
          if (typeof listGIApplication[0].warehouses === 'object') {
            warehouseList = Object.keys(listGIApplication[0].warehouses);
          }
        } else {
          paginationObj.total = 0;
          listGIApplication = [];
          warehouseList = ['']
        }
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading()
      })
  }

  const handleClear = () => {
    searchFilters = structuredClone(DEFAULT_FILTERS);
    selectedGoodsHierarchy = structuredClone(DEFAULT_GOODS_HIERARCHY);
    selectedWarehouseStorageItem = structuredClone(DEFAULT_WAREHOUSE_STORAGE)
    setCurrentFilter();
  }

  const onDownLoadGoodsApplicationList = () => {
    let payload = structuredClone(requestParams);
    downloadGoodsApplicationList(payload)
      .catch(error => { this.handleError(error) })
  }

  let sortObj = {
    sortBy: '',
    orderBy: '',
  }

  const _flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT
  }

  const _onSortClick = (sortBy) => {
    if (sortObj.sortBy === sortBy) {
      sortObj.orderBy = _flipOrderText(sortObj.orderBy)
    } else {
      sortObj.sortBy = sortBy;
      sortObj.orderBy = DESCENDING_TEXT;
    }
    getTableDataList();
  }

  const _getSortIcon = (sortBy) => {
    if (sortObj.sortBy !== sortBy) {
      return null
    }
    return sortObj.orderBy === DESCENDING_TEXT ? m('i.bi.bi-sort-down') : m('i.bi.bi-sort-up')
  }

  return {
    oninit: function () {
    },

    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m('.card-body',
            m('.position-relative',
              m(StorageLocationSelect, {
                selectedItem: selectedWarehouseStorageItem,
                onSelect: setSelectedWarehouseStorageItem
              }),

              (selectedWarehouseStorageItem.storageLocation.code) &&
              POSMAuthorizationModel.loadWithPOSMAuthority(
                m('button.btn.btn-primary.position-absolute.bottom-0.end-0',
                  {
                    onclick: () => {
                      isCreateApplicationDialogOpen = true;
                    },
                  },
                  m('i.bi.bi-plus-lg.me-0'),
                  this.getText('LT00001309', 'Goods Issue Application')
                ),
                POSM_PERMISSION_KEY.GOODS_ISSUE_APPLICATION
              )
            ),
            m('hr'),
            m(MultiplePOSMLevelSelect, { selectedItems: selectedGoodsHierarchy, onSelect: setSelectedGoodsHierarchy }),
            m('.row.g-2',
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label', this.getText('LT00000132', 'Date')),
                m('.input-group',
                  m(DatePickerComponent, {
                    class: 'form-control',
                    isRange: true,
                    readonly: true,
                    grid: 1,
                    calendars: 1,
                    dateStart: searchFilters.DateFrom && moment(searchFilters.DateFrom).format(formats.dateFormat),
                    dateEnd: searchFilters.DateTo && moment(searchFilters.DateTo).format(formats.dateFormat),
                    required: true,
                    onselect: (e) => {
                      setSearchFilter({
                        DateFrom: moment(e.detail.start).format(formats.apiDateFormat),
                        DateTo: moment(e.detail.end).format(formats.apiDateFormat)
                      })
                    }
                  })
                )
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label', this.getText('LT00001245', 'Retail')),
                m('.input-group', m(SelectSiteSearchInputComponent, {
                  id: 'site',
                  selectedItems: searchFilters.ChannelCode,
                  multiple: true,
                  onSelect: (selectedItem) => {
                    setSearchFilter({ ChannelCode: selectedItem })
                  }
                }))
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label', this.getText('LT00001322', 'Approval Status')),
                m('.input-group',
                  m(SingleSelectComponent, {
                    popoverAttrs: { class: 'posm-filters' },
                    items: Object.values(APPROVAL_STATUSES),
                    selectedItem: searchFilters.ApprovalStatusCode,
                    checkmark: true,
                    filterable: true,
                    keyOnly: true,
                    onSelect: (s) => {
                      setSearchFilter({ ApprovalStatusCode: s })
                    },
                  })
                )
              ),

              m('.col-12.d-flex.justify-content-end.gap-2',
                m(
                  'button.btn.btn-primary',
                  {
                    onclick: () => {
                      setPaginationObj({ pageSize: 10, pageIndex: 1 });
                      getTableDataList();
                    },
                  },
                  this.getText('LT00000001', 'Search')
                ),
                m(
                  'button.btn.btn-white',
                  {
                    onclick: () => {
                      handleClear();
                    },
                  },
                  this.getText('LT00000031', 'Clear')
                )
              )
            ),
          )
        ),
        m('.row',
          m('.col-12',
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.gap-3.mb-2',
                  m('a.btn.btn-primary',
                    {
                      class: listGIApplication?.length > 0 ? '' : 'disabled',
                      onclick: () => {
                        onDownLoadGoodsApplicationList()
                      }
                    },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table.table-hover.table-bordered", [
                        m("thead.thead-bggrey", { "style": "position : sticky ; top :1px; box-shadow: 0px -1px var(--is-link-blue)" },

                          m("tr.align-middle", { style: 'box-shadow: 0px 1px var(--blue-color-light)' }, [
                            m("th", { "scope": "col", "colspan": "21" }),
                            m("th", { "scope": "col", "colspan": warehouseList.length, "style": "text-align :center;" }, "Warehouse"),
                            m("th", { "scope": "col", "colspan": "6" }),
                          ]),
                          m("tr.align-middle",
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('MovementControlId') } }, _getSortIcon('MovementControlId'), this.getText('LT00001318', "Application ID")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('MovementDate') } }, _getSortIcon('MovementDate'), this.getText('LT00000132', "Date")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('GoodsIssueDate') } }, _getSortIcon('GoodsIssueDate'), this.getText('LT00001256', "Goods Issue Date")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('SubName') } }, _getSortIcon('SubName'), this.getText('LT00001332', "Sub Cate")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('GoodsName') } }, _getSortIcon('GoodsName'), this.getText('LT00001327', "Goods")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('GoodsControlId') } }, _getSortIcon('GoodsControlId'), this.getText("LT00001272", "Control No")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('MovementQty') } }, _getSortIcon('MovementQty'), this.getText('LT00001283', "Qty")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('MovementBy') } }, _getSortIcon('MovementBy'), this.getText('LT00001241', "Requester")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('FromWarehouse') } }, _getSortIcon('FromWarehouse'), this.getText('LT00001242', "From Warehouse")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('FromStorage') } }, _getSortIcon('FromStorage'), this.getText('LT00001243', "From Storage")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('ChannelCode') } }, _getSortIcon('ChannelCode'), this.getText('LT00000946', "Channel Code")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('ChannelName') } }, _getSortIcon('ChannelName'), this.getText('LT00000800', "Channel Name")),

                            m('th.cursor-pointer', { onclick: () => { _onSortClick('Owner') } }, _getSortIcon('Owner'), this.getText('LT00000838', "Contact Person")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('PhoneNo') } }, _getSortIcon('PhoneNo'), this.getText('LT00001329', "Phone No")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('Address') } }, _getSortIcon('Address'), this.getText('LT00001330', "Retail Address")),

                            m('th.cursor-pointer', { onclick: () => { _onSortClick('ApproveBy') } }, _getSortIcon('ApproveBy'), this.getText('LT00001323', "Approve By")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('ApproveDate') } }, _getSortIcon('ApproveDate'), this.getText('LT00001325', "Approve Date")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('ApproveBy2') } }, _getSortIcon('ApproveBy2'), this.getText('LT00001324', "Approve By 2")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('ApproveDate2') } }, _getSortIcon('ApproveDate2'), this.getText('LT00001326', "Approve Date 2")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('ApprovalStatus') } }, _getSortIcon('ApprovalStatus'), this.getText('LT00001322', "Approval Status")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('MovementMasterControlId') } }, _getSortIcon('MovementMasterControlId'), this.getText('LT00001239', "Movement Code")),

                            warehouseList.map(warehouseName => m('th.cursor-pointer', { onclick: () => { _onSortClick(warehouseName) } }, _getSortIcon(warehouseName), warehouseName)),

                            m('th.cursor-pointer', { onclick: () => { _onSortClick('Remarks') } }, _getSortIcon('Remarks'), this.getText('LT00000152', "Remarks")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('FileName1') } }, _getSortIcon('FileName1'), this.getText('LT00001248', "Proof 1")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('FileName2') } }, _getSortIcon('FileName2'), this.getText('LT00001249', "Proof 2")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('FileName3') } }, _getSortIcon('FileName3'), this.getText('LT00001250', "Proof 3")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('FileName4') } }, _getSortIcon('FileName4'), this.getText('LT00001251', "Proof 4")),
                            m('th.cursor-pointer', { onclick: () => { _onSortClick('FileName5') } }, _getSortIcon('FileName5'), this.getText('LT00001252', "Proof 5")),
                          )
                        ),
                        m("tbody",
                          (listGIApplication.length === 0) &&
                          m("tr", { "class": "align-middle" },
                            m("td", { "colspan": 28 }, this.getText("EM00000141", "No records found."))
                          ),
                          listGIApplication.length > 0 &&
                          listGIApplication.map((row, index) =>
                            m("tr.align-middle",
                              m("td",
                                m("button.btn.btn-link", {
                                  onclick: () => { selectedMovementControlId = row.MovementControlId }
                                }, row.MovementControlId)
                              ),
                              m("td", moment(row.MovementDate, formats.apiDateFormat).format(formats.dateFormat)),
                              m("td", moment(row.GoodsIssueDate, formats.apiDateFormat).format(formats.dateFormat)),
                              m('td', row.SubName),
                              m('td', row.GoodsName),
                              m('td', row.GoodsControlId),
                              m('td', row.MovementQty),
                              m('td', row.MovementBy),
                              m('td', row.FromWarehouse),
                              m('td', row.FromStorage),
                              m('td', row.ChannelCode),
                              m('td', row.ChannelName),

                              m('td', row.Owner),
                              m('td', row.PhoneNo),
                              m('td', row.Address),

                              m('td', row.ApproveBy),
                              m('td', row.ApproveDate),
                              m('td', row.ApproveBy2),
                              m('td', row.ApproveDate2),
                              m('td', row.ApprovalStatus),
                              m('td', row.MovementMasterControlId),

                              warehouseList.map(warehouseName => m('td', row.warehouses[warehouseName])),

                              m('td', row.Remarks),
                              m("td", m("button.btn.btn-link.btn-sm.text-truncate", {
                                "style": "max-width :200px",
                                type: 'button',
                                title: row.Remarks,
                                onclick: (e) => {
                                  e.preventDefault();
                                  goodMovementModel.downloadProofFile(row.FileId1, row.FileName1)
                                },
                              }, row.FileName1)),
                              m("td", m("button.btn.btn-link.btn-sm.text-truncate", {
                                "style": "max-width :200px",
                                type: 'button',
                                title: row.FileName2,
                                onclick: (e) => {
                                  e.preventDefault();
                                  goodMovementModel.downloadProofFile(row.FileId2, row.FileName2)
                                },
                              }, row.FileName2)),
                              m("td", m("button.btn.btn-link.btn-sm.text-truncate", {
                                "style": "max-width :200px",
                                type: 'button',
                                title: row.FileName3,
                                onclick: (e) => {
                                  e.preventDefault();
                                  goodMovementModel.downloadProofFile(row.FileId3, row.FileName3)
                                },
                              }, row.FileName3)),
                              m("td", m("button.btn.btn-link.btn-sm.text-truncate", {
                                "style": "max-width :200px",
                                type: 'button',
                                title: row.FileName4,
                                onclick: (e) => {
                                  e.preventDefault();
                                  goodMovementModel.downloadProofFile(row.FileId4, row.FileName4)
                                },
                              }, row.FileName4)),
                              m("td", m("button.btn.btn-link.btn-sm.text-truncate", {
                                "style": "max-width :200px",
                                type: 'button',
                                title: row.FileName5,
                                onclick: (e) => {
                                  e.preventDefault();
                                  goodMovementModel.downloadProofFile(row.FileId5, row.FileName5)
                                },
                              }, row.FileName5)),
                            )
                          )
                        )
                      ])
                    ),
                    listGIApplication.length > 0 &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: paginationObj.pageIndex,
                        pageSize: paginationObj.pageSize,
                        totalItems: paginationObj.total,
                        onPageChanged: (pageIndex) => {
                          setPaginationObj({ pageIndex })
                          getTableDataList();
                        },
                        onPageSizeChanged: (pageIndex, pageSize) => {
                          setPaginationObj({ pageIndex, pageSize });
                          getTableDataList();
                        },
                      })
                    )
                  )
                )
              )
            ),
            //End List
          ),
        ), ,

        /* CREATE GOODS ISSUE APPLICATION DIALOG */
        isCreateApplicationDialogOpen &&
        m(CreatePOSMGoodsIssueApplicationDialog, {
          isOpen: isCreateApplicationDialogOpen,
          selectedWarehouseStorageItem,
          onClose: (refresh = false) => {
            isCreateApplicationDialogOpen = false;
            if (refresh === true) {
              setPaginationObj({ pageSize: 10, pageIndex: 1 });
              getTableDataList()
            }
          }
        }),

        /* UPDATE GOODS ISSUE APPLICATION DIALOG */
        selectedMovementControlId &&
        m(UpdatePOSMGoodsIssueApplicationDialog, {
          isOpen: !!selectedMovementControlId,
          selectedWarehouseStorageItem,
          movementControlCode: selectedMovementControlId,
          onClose: (refresh = false) => {
            selectedMovementControlId = '';
            if (refresh === true) {
              setPaginationObj({ pageSize: 10, pageIndex: 1 });
              getTableDataList()
            }
          }
        }),

        this.getBaseViews(),
      ];
    },
  };
}
